var cache = {};

export default (search, page=1, per_page=20) => {
  return new Promise((resolve, reject) => {
    var cacheId = `${search}_${page}_${per_page}`;
    if(cache[cacheId] != null) {
      resolve(cache[cacheId]);
      return;
    }

    $.ajax({
      type: "GET",
      url: "/search_pixabay",
      data: {
        search: search,
        page: page,
        per_page: per_page
      }
    }).then((data) => {
      cache[cacheId] = data.data;
      resolve(data.data)
    }).catch(() => {
      reject()
    });
  });
}
